
type KycStatuses = keyof typeof kycStatues
const kycStatues: { [Status in KycStatus['status']]: Status } = {
    "created": "created",
    "pending": "pending",
    "completed": "completed",
    "approved": "approved",
    "declined": "declined",
    "needs_review": "needs_review",
    "expired": "expired",
    "failed": "failed",
}

const parseKycStatus = (data?: Partial<KycStatus>): KycStatus => ({
    id: data?.id || '',
    status: kycStatues[data?.status as KycStatuses] || 'failed',
    createdAt: data?.createdAt || "0001-01-01T00:00:00Z",
    updatedAt: data?.updatedAt || "0001-01-01T00:00:00Z",
    completedAt: data?.completedAt || "0001-01-01T00:00:00Z",
})

export { parseKycStatus }